module.exports = __webpack_public_path__ + "static/img/69-2.e4c3f46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/69-2.jpg
// module id = I74N
// module chunks = 0